export default __webpack_public_path__ + "static/promo3-142d99d315fa360c6083fc7c7dff3daa.mp4";